import { Injectable } from '@angular/core';
import { Centrifuge, ServerPublicationContext } from 'centrifuge';
import { Observable } from 'rxjs';

import { ISocketMessage } from '@hosty-app/types';

import { environment } from '../../environments/environment';

export interface CentrifugeBase {
  listen(token: string, userID: number): Observable<ISocketMessage<any>>;
}

@Injectable({ providedIn: 'root' })
export class CentrifugeNextService implements CentrifugeBase {
  #offset: number | null = null;

  listen(token: string, userId: number): Observable<ISocketMessage<any>> {
    return new Observable((o) => {
      const instance = new Centrifuge(environment.baseWsUrl, {
        debug: /*isDevMode()*/ false,
        token,
      });
      instance.connect();
      instance.on('connected', () => {
        instance
          .history(
            `user#${userId}`,
            this.#offset === null
              ? {
                  limit: 0,
                  reverse: true,
                }
              : {
                  limit: 10,
                  since: { offset: this.#offset, epoch: '' },
                },
          )
          .then((res) => {
            res.publications.forEach((p) => {
              o.next(p.data);
            });
            this.#offset = res.offset;
          });
      });
      instance.on('publication', (ctx: ServerPublicationContext) => {
        o.next(ctx.data);
        this.#offset = ctx.offset ?? null;
      });
      instance.on('error', (err) => {
        o.error(err);
      });
      instance.on('disconnected', () => {
        o.complete();
      });

      return () => {
        instance.disconnect();
      };
    });
  }
}
